import { client } from 'app/http';
import { TTransactionCode } from 'app/types/entities/TTransactionCode';

export const getTransactionCode = async (code: string): Promise<TTransactionCode> => {
  const result = await client.get(`/transaction-codes/${code}`);
  return result.data;
};
